import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from "@angular/core"

@Component({
    selector: "flow-switch",
    templateUrl: "./flow-switch.component.html",
    styleUrl: "./flow-switch.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class FlowSwitchComponent {
  @Input() checked: boolean = false
  @Input() disabled: boolean = false
  @Input() ariaLabel: string = ""
  @Output() checkedChange = new EventEmitter<boolean>()

  public toggle(): void {
    if (this.disabled) return
    this.checked = !this.checked
    this.checkedChange.emit(this.checked)
  }

  public onKeydown(event: KeyboardEvent): void {
    if (event.key === " " || event.key === "Spacebar" || event.key === "Enter") {
      event.preventDefault()
      this.toggle()
    }
  }
}
